import axios from 'axios'

export default class SystemUser {
  /**
   * 发送验证码
   * @param phone 发送的手机号
   * @param checkSign 螺丝冒ID
   * @return {Promise<AxiosResponse | never>}
   */
  getSMSCode (phone, checkSign) {
    return axios.post(`http://webapi.i200.cn/v1/mobile/recommand/register/create-validation`, { phone: phone, checkSign: checkSign }).then(res => {
      return res.data
    })
  }

  /**
   * 注册方法
   * @param params {Object} {pin: validationId: 'xcxcxc', phoneNumber: 23141234123, password: 23242342342, code: as4234}
   * code 推荐码  pin 验证码
   */
  register (params) {
    return axios.post(`http://webapi.i200.cn/v1/mobile/recommand/register/create-account`, params).then(res => {
      return res.data
    })
  }

  /**
   * 根据code 获取对应的推荐人信息
   * @param code
   * @return {Promise<AxiosResponse | never>}
   */
  getIntroducerInfo (code) {
    return axios.get(`http://webapi.i200.cn/v1/mobile/recommand/recommand-account-info?code=${code}`).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/model/register-yaoqing/index.js